import { render } from "./Goods.vue?vue&type=template&id=03a85268"
import script from "./Goods.vue?vue&type=script&lang=js"
export * from "./Goods.vue?vue&type=script&lang=js"

import exportComponent from "/Users/rockroc/Code/project/hogonmr-resource/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__